import { render, staticRenderFns } from "./dashboardConfig.vue?vue&type=template&id=842fcdae&scoped=true"
import script from "./dashboardConfig.vue?vue&type=script&lang=js"
export * from "./dashboardConfig.vue?vue&type=script&lang=js"
import style0 from "./dashboardConfig.vue?vue&type=style&index=0&id=842fcdae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842fcdae",
  null
  
)

export default component.exports